import { routes } from 'constants/config';
import useFetch from './useFetch';

/**
 *  @typedef {Object} UseFetchReturn
 *  @property {boolean} isJointUser joint user status of the current user
 *  @property {boolean} loading loading state of the request, changes to true when params changes
 *  @property {any} error any error returned from the json endpoint
 */

/**
 * useIsJointUser - Hook uses the useFetch hook to GET data from the joint_user endpoint
 *
 * @return {UseFetchReturn} The return value of useFetch, an object describing the state of the hook
 */
const useIsJointUser = () => {
  const { data, loading, error } = useFetch(routes.SEISMIC.JOINT_USER);

  const isJointUser = data?.jointUser || false;

  return { isJointUser, loading, error };
};

export default useIsJointUser;
